import React, { useEffect, useState } from 'react'
import Provider from './Provider'
import { remove, debounce } from 'lodash'
import { Grid } from '@material-ui/core'
import { IUserControlledFieldProps, MaxValues } from './Interface'
import useStyles, { AddCircleIcon } from './Styles'
import { EditableField } from '../../components/editable-field'

const UserControlledField: React.FC<IUserControlledFieldProps> = ({ maxValues, initialValues, onSave, disabled }) => {
  const [values, setValues] = useState(initialValues)
  const classes = useStyles({})

  useEffect(() => {
    setValues(initialValues)
  }, [initialValues])

  const removeField = (key: number) => (evt: any) => {
    evt.preventDefault()
    evt.stopPropagation()
    remove(values, (_, i) => key === i)
    const newValues = [...values]
    setValues(newValues)
    onSave(newValues)
  }

  const onChange = (key: number) => {
    return (value: any) => {
      values[key] = { ...values[key], value }
      const newValues = [...values]
      setValues(newValues)
    }
  }

  const onBlur = (key: number) => {
    return debounce(() => {
      if (values[key]) {
        const newValues = values.filter(({ value }: any) => value && value.trim())
        setValues(newValues)
        onSave(newValues)
      }
    }, 300)
  }

  const renderAddFieldButton = () => {
    return !disabled && values.length < maxValues ? (
      <div className={classes.row}>
        <div onClick={() => setValues([...values, {}])}>
          <AddCircleIcon fontSize="large" />
        </div>
      </div>
    ) : null
  }

  return (
    <Grid container direction="column" justify="center">
      <Grid item xs={4}>
        {values.map((item: any, key: number) => {
          return (
            <EditableField
              id={key.toString()}
              key={key}
              value={item.value}
              onBlur={onBlur(key)}
              onChange={onChange(key)}
              onRemoveValue={removeField(key)}
              hideDeleteIcon={!key}
              disabled={disabled}
            />
          )
        })}
        {renderAddFieldButton()}
      </Grid>
    </Grid>
  )
}

UserControlledField.defaultProps = {
  onSave: () => {},
  maxValues: MaxValues.DEFAULT,
  initialValues: [{}]
}

export default (props: any) => (
  <Provider>
    <UserControlledField {...props} />
  </Provider>
)
